import { get, post, del } from '@elementary/common-ui/utils/http';
import {
  CreateTokenRequest,
  CreateTokenResponse,
  GetTokensResponse,
} from '../../shared/types';

export const getPersonalTokens = async (): Promise<GetTokensResponse> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/user/settings/personal-tokens`);

export const createPersonalToken = async (
  data: CreateTokenRequest,
): Promise<CreateTokenResponse> =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/user/settings/personal-tokens`,
    data,
  );

export const deletePersonalToken = async (tokenId: string): Promise<void> =>
  del(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/user/settings/personal-tokens/${tokenId}`,
  );
